<p-fieldset>
    <p-header class="article-title">
      <div class="article-title">{{ "OWNERS" | translate }}</div>
    </p-header>
    <div class="table">
      <p-table
        [value]="logsTable()"
        [rows]="5"
        [paginator]="true"
        autoLayout="true"
        alwaysShowPaginator="false"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{ "NAME" | translate }}</th>
            <th>{{ "QUOTA" | translate }}</th>
            <th>{{ 'Compartilha fatura' | translate}}</th>
          </tr>
        </ng-template>
        <ng-template
          pTemplate="body"
          let-boatCustomer
          let-rowIndex="rowIndex"
        >
          <tr [ngClass]="{'item-new-log': isChanged(boatCustomer) && isNew, 'item-old-log': isChanged(boatCustomer) && !isNew}">
            <td>
              <span>
                {{ boatCustomer.name }}
              </span>
            </td>
            <td>
                <span>
                  {{ boatCustomer.quota }}
                </span>
            </td>
            <td>
                <span>
                  {{ boatCustomer.sharedInvoiceCustomerApp?'Ativo':'Inativo' }}
                </span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-fieldset>
  <br />